export default __webpack_public_path__ + "static/dohyeonkim-afd70a8481a2ccca1f416e84e5ff1318.jpeg";